import React, { Component } from 'react';

import PropTypes from 'prop-types';

import firebase from 'firebase/app';

import { withStyles } from '@material-ui/core/styles';

import Hidden from '@material-ui/core/Hidden';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';

import GoogleIcon from 'mdi-material-ui/Google';
import appleLogo from '../../assets/apple-logo.png'

const styles = (theme) => ({
  dialogActions: {
    justifyContent: 'center',
    marginTop: theme.spacing(2.5),
    marginBottom: theme.spacing(1)
  },
  dialogActionsMobile: {
    display: 'grid',
    justifyContent: 'stretch',
    marginTop: theme.spacing(2.5),
    marginBottom: -theme.spacing(0.5)
  },
  button: {
    marginTop: theme.spacing(1.5),
    textTransform: 'none',
    '&:hover': {
      opacity: 0.8,
    },
  },
  disabledButton: {
    color: '#fff !important',
    backgroundColor: `${theme.palette.gray} !important`,
  },
  buttonMobile: {
    marginBottom: theme.spacing(1.5)
  },
  google: {
    backgroundColor: '#4285f4',
    color: '#fff',
    '&:hover': {
      backgroundColor: '#4285f4',
    },
  },
  apple: {
    backgroundColor: '#000',
    color: '#fff',
    '&:hover': {
      backgroundColor: '#000',
    },
  },
});

class AuthProviderList extends Component {

  handleGoogleProviderClick = () => {
    const { onAuthProviderClick } = this.props;
    const googleProvider = new firebase.auth.GoogleAuthProvider()

    // NOTE: force prompting user to select account, which is crucial for people using multiple Google accounts
    // source: https://firebase.google.com/docs/auth/web/google-signin#web_6
    // source: https://developers.google.com/identity/openid-connect/openid-connect#authenticationuriparameters
    googleProvider.setCustomParameters({
      prompt: "select_account",
    });

    onAuthProviderClick(googleProvider);
  }

  handleAppleProviderClick = () => {
    const { onAuthProviderClick } = this.props;

    onAuthProviderClick(new firebase.auth.OAuthProvider('apple.com'));
  }

  render() {
    // Styling
    const { classes } = this.props;

    // Properties
    const { isPerformingAuthAction } = this.props;

    return (
      <React.Fragment>
        <Hidden only="xs">
          <DialogActions className={classes.dialogActions}>
            <Button 
              className={`${classes.google} ${classes.button}`} 
              disabled={isPerformingAuthAction} 
              variant="contained" 
              onClick={this.handleGoogleProviderClick}
              startIcon={<GoogleIcon fontSize="small" />}
            >
              Sign in with Google
            </Button>
            <Button 
              className={`${classes.apple} ${classes.button}`} 
              disabled={isPerformingAuthAction} 
              variant="contained" 
              onClick={this.handleAppleProviderClick}
              startIcon={<img src={appleLogo} height={18} alt="Apple logo" style={{ filter: 'invert(1)'}} />}
            >
              Sign in with Apple
            </Button>
          </DialogActions>
        </Hidden>

        <Hidden only={['sm', 'md', 'lg', 'xl']}>
          <DialogActions className={classes.dialogActionsMobile} disableSpacing>
            <Button 
              className={`${classes.google} ${classes.buttonMobile}`} 
              disabled={isPerformingAuthAction} 
              variant="contained" 
              onClick={this.handleGoogleProviderClick}
              startIcon={<GoogleIcon fontSize="small" />}
            >
              Sign in with Google
            </Button>
            <Button 
              className={`${classes.apple} ${classes.buttonMobile}`} 
              disabled={isPerformingAuthAction} 
              variant="contained" 
              onClick={this.handleAppleProviderClick}
              startIcon={<img src={appleLogo} height={18} alt="Apple logo" style={{ filter: 'invert(1)'}} />}
            >
              Sign in with Apple
            </Button>
          </DialogActions>
        </Hidden>
      </React.Fragment>
    );
  }
}

AuthProviderList.propTypes = {
  classes: PropTypes.object.isRequired,

  isPerformingAuthAction: PropTypes.bool,

  onAuthProviderClick: PropTypes.func.isRequired
};

export default withStyles(styles)(AuthProviderList);
